import { MockServiceStore } from "./MockServiceStore";

/**
 * StructureCast - Pre-Production Meeting
 */
export interface StructureCastPreProductionMeeting {
  id: string;
  projectId: string;
  meetingDate: string;
  personnelPresent: {
    productionManager: string;
    engineer: string;
    qc: string;
    forming: string;
    productionLead: string;
    other: string[];
  };
  drawingsReceived: boolean;
  scheduleReceived: boolean;
  budgetReceived: boolean;
  materialsCheck: string;
  specialItems: string[];
  productionScheduleNotes: string;
  handlingStorageNotes: string;
  distributedBy: string;
  distributionDate: string;
  productionHold: boolean;
  followUpMeetingDate: string;
  createdAt: string;
  updatedAt: string;
}

export const mockStructureCastPreProductionMeetings: StructureCastPreProductionMeeting[] = [
  {
    id: "sc-ppm-1",
    projectId: "sc-proj-1",
    meetingDate: "2026-01-08",
    personnelPresent: {
      productionManager: "Mid-State Production Manager",
      engineer: "Shop Engineer",
      qc: "QC Lead",
      forming: "Form Lead",
      productionLead: "Yard Lead",
      other: ["Office (Estimating)", "HRCSD — Greg Hill"],
    },
    drawingsReceived: true,
    scheduleReceived: true,
    budgetReceived: true,
    materialsCheck: "5,000 PSI Type II/V mix confirmed with CalPortland Santa Maria. #4 and #6 rebar on hand from Coast Steel & Rebar. Press-Seal HWB pipe boots (8\"/10\"/12\") on order from Press-Seal. 1900 Sanitary Sewer CPH frames + covers staged for shipping with each MH. CS-102 butyl sealant on hand. Polypropylene fibers (Caltrans secondary reinforcing) confirmed.",
    specialItems: [
      "48\" sanitary sewer manhole system per Heritage Ranch WRRF drawings",
      "Press-Seal HWB pipe boots cast into bases per penetration schedule",
      "CS-102 butyl sealant between all sections (per Mid-State spec)",
      "1900 Sanitary Sewer CPH frame + cover (H20 wheel loading)",
      "Pre-Pour and Post-Pour QC inspection checklists per ASTM C478",
      "48\" base, riser, eccentric cone forms — all 48\" inside diameter, 60\" outside",
    ],
    productionScheduleNotes: "4 casting groups: Deep MH (Jan 19-20), Standard MH (Jan 26-28), Mid-Depth MH (Feb 2-3), Shallow MH (Feb 9-10). Target ~4.5 CY/day capacity. Bases on Day 1, risers/cones on Day 2, grade rings on Sump position. Eccentric cone forms switch between 18\"/24\"/36\" heights — pre-stage day before.",
    handlingStorageNotes: "All sections stored upright on level ground with dunnage at Santa Maria yard. Cones stored inverted on dunnage. Minimum 7-day cure before shipping. F.O.B. Mid-State yard — hourly delivery charge to Heritage Ranch (~50 mi up US-101). Crane at jobsite required for setting.",
    distributedBy: "Office (MSCP)",
    distributionDate: "2026-01-09",
    productionHold: false,
    followUpMeetingDate: "2026-01-16",
    createdAt: "2026-01-08T00:00:00.000Z",
    updatedAt: "2026-01-09T00:00:00.000Z",
  },
  {
    id: "sc-ppm-2",
    projectId: "sc-proj-1",
    meetingDate: "2026-01-16",
    personnelPresent: {
      productionManager: "Mid-State Production Manager",
      engineer: "Shop Engineer",
      qc: "QC Lead",
      forming: "Form Lead",
      productionLead: "Yard Lead",
      other: [],
    },
    drawingsReceived: true,
    scheduleReceived: true,
    budgetReceived: true,
    materialsCheck: "All materials on-site. 5,000 PSI trial batch passed QC (slump 4.5\", air 5.8%, temp 68°F). Forms inspected and oiled. Press-Seal HWB 10\" boots running tight against Group 2 reservation — reorder placed.",
    specialItems: [
      "QC checklists (Pre-Pour / Post-Pour) confirmed per ASTM C478",
      "Batch ticket tracking active — all tickets logged per casting day",
      "Form release oil per Nox-Crete specifications",
      "Rebar: $40/20ft, 1900 CPH frame + cover set: $425/ea (per quote #25-1585)",
      "Eccentric cone form changeover plan: 36\" → 24\" → 18\" by group",
    ],
    productionScheduleNotes: "Group 1 (Deep MH) production starts Monday 1/19. SSMH-01 + SSMH-02 bases scheduled Day 1. 48\" and 36\" risers + 36\" eccentric cones + grade rings Day 2. Forms ready, rebar cages prefabricated.",
    handlingStorageNotes: "Storage yard zones 1-3 allocated for cured manhole sections. Stack max 2 high with timber spacers for bases. Cones stored inverted on dunnage. Central Coast mild winter — no cold weather protocol needed.",
    distributedBy: "Office (MSCP)",
    distributionDate: "2026-01-16",
    productionHold: false,
    followUpMeetingDate: "",
    createdAt: "2026-01-16T00:00:00.000Z",
    updatedAt: "2026-01-16T00:00:00.000Z",
  },
];

export const createMockStructureCastPreProductionMeetingStore = () =>
  new MockServiceStore<StructureCastPreProductionMeeting>({
    mockData: mockStructureCastPreProductionMeetings,
    idField: "id",
    simulateDelay: 200,
    persistKey: "preferred-structurecast-pre-production-meetings",
  });

export default mockStructureCastPreProductionMeetings;
